export const UPDATE_RESTAURANT_SETTINGS_SUCCESS = "redux_store:settings.success.update_restaurant";
export const UPDATE_EMAIL_SETTINGS_SUCCESS = "redux_store:settings.success.update_email";

export const ADD_OPENING_HOUR_SUCCESS = "redux_store:settings.success.add_opening_hour";
export const DELETE_OPENING_HOUR_SUCCESS = "redux_store:settings.success.delete_opening_hour";
export const UPDATE_OPENING_HOUR_SUCCESS = "redux_store:settings.success.update_opening_hour";

export const ADD_CUSTOM_EVENT_SUCCESS = "redux_store:settings.success.add_custom_event";
export const DELETE_CUSTOM_EVENT_SUCCESS = "redux_store:settings.success.delete_custom_event";
export const UPDATE_CUSTOM_EVENT_SUCCESS = "redux_store:settings.success.update_custom_event";

export const ADD_MESSAGE_SAMPLE_SUCCESS = "redux_store:settings.success.add_message_sample";
export const UPDATE_MESSAGE_SAMPLE_SUCCESS = "redux_store:settings.success.update_message_sample";
export const DELETE_MESSAGE_SAMPLE_SUCCESS = "redux_store:settings.success.delete_message_sample";

export const ADD_RESERVATION_CONDITION_SUCCESS = "redux_store:settings.success.add_reservation_condition";
export const UPDATE_RESERVATION_CONDITION_SUCCESS = "redux_store:settings.success.update_reservation_condition";
export const DELETE_RESERVATION_CONDITION_SUCCESS = "redux_store:settings.success.delete_reservation_condition";

export const ADD_SPECIAL_OPTION_CATEGORY_SUCCESS = "redux_store:settings.success.add_special_option_category";
export const UPDATE_SPECIAL_OPTION_CATEGORY_SUCCESS = "redux_store:settings.success.update_special_option_category";
export const DELETE_SPECIAL_OPTION_CATEGORY_SUCCESS = "redux_store:settings.success.delete_special_option_category";

export const ADD_SPECIAL_OPTION_SUCCESS = "redux_store:settings.success.add_special_option";
export const UPDATE_SPECIAL_OPTION_SUCCESS = "redux_store:settings.success.update_special_option";
export const DELETE_SPECIAL_OPTION_SUCCESS = "redux_store:settings.success.delete_special_option";



// WEBPACK FOOTER //
// ./src/successes/settings.js